import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function PakkeforsendelsePrivate() {
  return (
    <>
      <SEO
        title="Fragt af Pakker for Private | Fastlane ApS"
        description="Præcis fragt af pakker ved import og eksport af møbler, lamper, reservedele, elektronik, private ejendele med videre."
        keywords="møbler;lamper;"
        canonicalUrl="https://fastlane.dk/pakkeforsendelse-private"
      />

      <PageHeader
        title="Pakkeforsendelse Private"
        subtitle="Sikker og prisvenlig pakkefragt for private ved nethandel, arvegods, møbler og lamper i Europa og verden."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Pakkeforsendelse Private' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              Fastlane kan via vort netværk af transportører tilbyde sende pakker og mindre forsendelser i det meste af verdenen. Skal man sende eller modtage gods til eller fra 3. land altså lande uden for EU så skal man være opmærksom på, at der typisk skal laves en udførsel i afsender landet og en fortoldning i modtager landet.
            </p>
            <div className="p-4 bg-amber-50 rounded-xl border border-amber-200 text-sm text-amber-900 font-medium">
              Bemærk venligst Norge og Schweiz er ikke med i toldunionen EU.
            </div>
            <p>
              Vi arrangerer også <Link to="/ekspres-kurer-i-direkte-lastbiler" className="text-sky-700 font-semibold underline">dedikerede lastbiler</Link> fra A til B (dør til dør).
            </p>
          </div>

          {/* Hvorfor outsource via os som privat */}
          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200/90 space-y-4">
            <h3 className="text-xl font-bold text-[#0f2b48]">Fordele for private transportkøbere:</h3>
            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Vi har som professionelle indkøbere typisk langt bedre pakkerater end private opnår ved at gå direkte til de store pakketransportører med en enkelt forsendelse.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Vi kender pakkesystemerne og undgår de faldgruber som man ellers let falder i.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Vi følger op på at forsendelsen rent faktisk levere som forventet.</span>
              </li>
            </ul>
          </div>

          {/* Typiske behov */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-[#0f2b48]">Behov for eksport og/eller import af pakker kan opstå ved:</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-5 rounded-xl border border-slate-200 bg-white">
                <i className="fa-solid fa-cart-shopping text-sky-700 text-xl mb-2" aria-hidden="true" />
                <h4 className="font-bold text-sm text-slate-900 mb-1">Handel på nettet</h4>
                <p className="text-xs text-slate-600">Typisk møbler, elektronik, tøj, cykler, lamper m.m.</p>
              </div>
              <div className="p-5 rounded-xl border border-slate-200 bg-white">
                <i className="fa-solid fa-people-carry-box text-sky-700 text-xl mb-2" aria-hidden="true" />
                <h4 className="font-bold text-sm text-slate-900 mb-1">Midlertidig flytning</h4>
                <p className="text-xs text-slate-600">Private ejendele i flyttekasser over landegrænser.</p>
              </div>
              <div className="p-5 rounded-xl border border-slate-200 bg-white">
                <i className="fa-solid fa-couch text-sky-700 text-xl mb-2" aria-hidden="true" />
                <h4 className="font-bold text-sm text-slate-900 mb-1">Arvegods</h4>
                <p className="text-xs text-slate-600">Skånsom og sikker fragt af familiære værdigenstande.</p>
              </div>
            </div>
          </div>

          {/* Emballering rådgivning */}
          <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed border-t border-slate-200 pt-8">
            <h3 className="text-xl font-bold text-[#0f2b48]">Emballering og afhentning</h3>
            <p>
              Godset skal altid være emballeret, pakket og mærket korrekt. Det er ofte en udfordring ved køb af møbler og lamper. Ved pakketransport af møbler og lamper er det et krav at godset er emballeret virkeligt godt så pakkeforsendelsen kan tåle håndteringen undervejs.
            </p>
            <p>
              Det skal være muligt at afhente godset i normal åbningstid og at levere godset i normal åbningstid.
            </p>
            <p>
              Lokalt kan vi tilbyde, at emballere, pakke og mærke godt til forsendelse, hvis du leverer ind til vort lager i Esbjerg.
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Send os detaljerne på den genstand du skal have fragtet:</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Forespørg fragtpris
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
